import { type HTMLAttributes } from "react";
import { Table } from "antd";
import { TableConfig, DataType } from "../../model/types";

import "./configurable.table.scss";

interface ConfigurableTableProps {
  dataSource: DataType[];
  config: TableConfig;
  loading?: boolean;
  rowKey?: string | ((record: DataType) => string);
  onRow?: (
    record: DataType,
    index?: number,
  ) => HTMLAttributes<HTMLElement>;
}

export function ConfigurableTable({
  dataSource,
  config,
  loading = false,
  rowKey = "key",
  onRow,
}: ConfigurableTableProps) {
  const { columns } = config;

  return (
    <Table
      className="ant-table-pagination"
      dataSource={dataSource}
      columns={columns}
      loading={loading}
      rowKey={rowKey}
      onRow={onRow}
      pagination={{
        position: ["bottomLeft"],
        showSizeChanger: false,
        showQuickJumper: false,
        showTotal: undefined,
        pageSize: 5,
        showLessItems: true,
      }}
    />
  );
}
